<template>
  <div class="app-body_show container-fluid pt-4 pb-5 search">
    <search-container
      v-if="isLoaded && !isEmpty(searchFilterObject)"
      :isWithFixedFilter="searchFilterObject"
    />
  </div>
</template>

<script>
import SearchContainer from '@/containers/Search'

export default {
  name: 'researchGroupExplore',
  components: {
    SearchContainer
  },
  props: {
    isLoaded: {
      type: Boolean,
      required: true
    },
    searchFilterObject: {
      type: Object,
      required: true
    }
  }
}
</script>
